import {
  miniApp,
  openLink,
  retrieveRawInitData,
  themeParams,
  init as sdkInit,
} from '@telegram-apps/sdk';

import { api } from '~/shared/lib/api';
import i18next from '~/shared/lib/i18n';

type TokenDTO = {
  data: {
    expiresAt: string;
    token: string;
  };
};

const parseQuery = (query: string) => {
  const data = new URLSearchParams(query);

  return {
    user: JSON.parse(data.get('user') || '{}'),
  };
};

const TEST_DEMO_USER = {
  id: 777777777,
  first_name: 'Alexey',
  last_name: 'Nikolaev',
  username: 'AlexNick',
  language_code: 'ru',
  is_premium: true,
  allows_write_to_pm: true,
  photo_url:
    'https://pbs.twimg.com/profile_images/1671976628900208641/qCC_Ao-5_400x400.jpg',
};

export const telegram = {
  closeMiniApp: () => {
    try {
      if (miniApp.close.isAvailable()) {
        miniApp.close();
      } else {
        console.warn('miniApp.close is not available');
        // Fallback for some environments
        (window as any).Telegram?.WebApp?.close();
      }
    } catch (error) {
      console.error('Failed to close Mini App:', error);
    }
  },
  createToken: async (param: string | null) => {
    const isDevelopment = process.env.ENV === 'development';
    const useDemoUser = process.env.USE_DEMO_USER === 'true';
    let initData = isDevelopment ? process.env.INIT_DATA_RAW : '';
    let user = TEST_DEMO_USER;

    // Если явно не включен режим демо пользователя, получаем настоящий initData
    if (!useDemoUser) {
      if (!isDevelopment) {
        try {
          const initDataRaw = retrieveRawInitData();

          initData = initDataRaw as string;
          // eslint-disable-next-line no-empty
        } catch {}
      }

      if (!initData) {
        throw new Error('Не удалось получить initData.');
      }

      const decodedInitData = decodeURIComponent(initData);

      const { user: userData } = parseQuery(decodedInitData);
      user = userData;
    }

    const query = new URLSearchParams(window.location.search);
    const appId = query.get('app_id');
    i18next.changeLanguage(appId || user.language_code || 'en');

    const {
      data: { expiresAt, token },
    } = await api.post<{ colorScheme: string; webapp: string }, TokenDTO>(
      '/api/v1/authorize/telegram',
      {
        colorScheme: 'dark',
        initData,
        payload: {
          ref: param,
        },
        themeParams,
        locale: user.language_code,
      },
    );

    return { expiresAt, token, user };
  },
  init: () => {
    sdkInit();
    if (miniApp.mount.isAvailable()) {
      void miniApp.mount();
    }
  },
  ready: () => {
    if (miniApp.ready.isAvailable()) {
      miniApp.ready();
    }
  },
  openLink,
};
